import { ref } from 'vue'
import { User } from './apps/go/interfaces/User'
export const user = ref<User>(JSON.parse(localStorage.user || '{}'))
